class CustomQUantityPicker {
    constructor() {
        this.buttonPlus;
        this.buttonMinus;
        this.input;
        this.tinsList;

        this.init();
    }

    init() {
        document.addEventListener("DOMContentLoaded", () => {
            const pickerElement = document.querySelector("[data-quantity-picker]");

            if (!pickerElement) return;

            this.container = pickerElement.closest(".shopify-section");
            this.buttonPlus = pickerElement.querySelector("[data-quantity-picker-plus]");
            this.buttonMinus = pickerElement.querySelector("[data-quantity-picker-minus]");
            this.input = pickerElement.querySelector("[data-quantity-picker-input]");
            this.max = this.input.max;

            this.stickyAtc = this.container.querySelector(".btn-atc .totprice");

            const debouncedOnChange = debounce(this.updateStickyAtcPrice.bind(this), 0);

            this.input.addEventListener("input", () => {
                this.updateQuantityElements();

                if (window.purchaseType === "default") {
                    this.initTinsQty();
                } else {
                    this.initSubsQty();
                }

                if (this.stickyAtc) {
                    debouncedOnChange();
                }
            });

            this.buttonPlus.addEventListener("click", () => {
                this.input.stepUp();
                this.input.dispatchEvent(new Event("input"));
            });

            this.buttonMinus.addEventListener("click", () => {
                this.input.stepDown();
                this.input.dispatchEvent(new Event("input"));
            });
        })
    }

    updateQuantityElements() {
        let qtyElements;
        const customQtySection = this.container.querySelector("[data-custom-qty]");

        if(customQtySection) {
            qtyElements = customQtySection.querySelectorAll("[data-qty]");
        } else {
            qtyElements = this.container.querySelectorAll("[data-qty]");
        }
        
        [...qtyElements].map(item => item.setAttribute("data-qty", this.input.value));
    }

    initTinsQty() {
        const tinsWrapper = this.container.querySelector("[data-custom-quantity-tins]");
        this.tinsList = this.container.querySelectorAll("[data-custom-quantity-tins]:not(.hidden) .custom-quantity-tins__item[data-price-default]");

        if (tinsWrapper && !tinsWrapper.classList.contains("hidden")) {
            this.setNewTinsPrice(this.input.value);
            this.setActiveTin(this.input.value);
        }
    }

    initSubsQty() {
        const sellingPlanButton = this.container.querySelector("[data-selling-plan-button]");

        if (sellingPlanButton) {
            this.setNewSubsPrice(sellingPlanButton, this.input.value)
        }
    }

    setNewSubsPrice(sellingPlanButton, quantity) {
        if (quantity) {
            const priceValue = sellingPlanButton.getAttribute("data-price-subs-value");
            const price = this.calculatePrice(priceValue, quantity, 1);
            const newPriceEl = sellingPlanButton.querySelector(".product-subs-collagen__button-price--new");

            if (newPriceEl && price) {
                newPriceEl.innerText = price;
            }
        }
    }

    setNewTinsPrice(quantity) {
        const selectorEl = this.container.querySelector("[data-default-button-subs]");
        const { discount, price, compareAtPrice } = this.getActiveTinDiscountAndPrice(quantity);
        const newPrice = this.calculatePrice(price, quantity, discount);
        const comparePrice = this.calculatePrice(compareAtPrice, quantity, 1);

        if (selectorEl) {
            const compareAtPriceEl = selectorEl.querySelector(".product-subs-collagen__button-price--old");
            const newPriceEl = selectorEl.querySelector(".product-subs-collagen__button-price--new");
            
            if (newPriceEl) {
                newPriceEl.innerText = newPrice;
            }

            if (compareAtPriceEl) {
                if (!compareAtPrice) {
                    if (!compareAtPriceEl.classList.contains("hidden")) {
                        compareAtPriceEl.classList.add("hidden")
                    }
                } else {
                    compareAtPriceEl.classList.remove("hidden")
                }

                compareAtPriceEl.innerText = comparePrice;
            } 

            selectorEl.setAttribute("data-price", newPrice);
        }
    }

    getActiveTinDiscountAndPrice(quantity) {
        let index;
        
        if (quantity <= 2) {
            index = 0;
        } else if(quantity >= 3 && quantity < 6) {
            index = 1;
        } else {
            index = 2;
        }

        const activeTin = this.tinsList[index];

        if (activeTin) {
            const discount = activeTin.getAttribute("data-discount-value");
            const price = activeTin.getAttribute("data-price-default");
            const compareAtPrice = activeTin.getAttribute("data-compare-at-price-default");

            return { discount, price, compareAtPrice };
        }

        return {};
    }

    setActiveTin(quantity) {
        [...this.tinsList].map(tin => {
            if (+tin.value === +quantity) {
                if (!tin.classList.contains("active")) {
                    tin.classList.add("active");
                }
            } else {
                tin.classList.remove("active");
            }

            return tin;
        });
    }

    calculatePrice(price, quantity, discount) {
        return formatMoney(+price * +quantity * +discount, window.price.money_format);
    }

    updateStickyAtcPrice() {
        const activePriceEl = this.container.querySelector("[data-subs-container] .product-subs-collagen__button.active .product-subs-collagen__button-price--new");

        if (activePriceEl) {
            this.stickyAtc.innerText = activePriceEl.innerText;
        }
    }
}

new CustomQUantityPicker();